import React from 'react';
import ErrorPage from './ErrorPage';

function ErrorPage404 () {
  return <ErrorPage message="There's nothing here" />;
}

export default ErrorPage404;
